// removed by extract-text-webpack-plugin
module.exports = {"errorBox":"ErrorBox-errorBox-55ffc7e4","noResults":"ErrorBox-noResults-2c7e0e54"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/ErrorBox.scss
// module id = 626
// module chunks = 0